import axios from "axios";
import cookie from "react-cookies";
import { useConfigStore } from "../store/config";
import { getURLDomain, logoutFunction } from "../common/utils";
import {
  // RIMS_LOCAL_STG_CONSTANTS,
  RIMS_COOKIE_CONSTANTS,
} from "../constants/index";
import SnackbarUtils from "../component/NotistackPlus";

export const basicUrl = process.env.REACT_APP_API_GETWAY;
export const adminCenterBasicUrl =
  process.env.REACT_APP_API_GETWAY_ADMIN_CENTER;
const URLDomain = getURLDomain();
const refreshURL = "/common-auth/refresh";
const redirectURL = `https://portal.${URLDomain}`;

const service = axios.create({
  baseURL: basicUrl,
});

service.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    let token = cookie.load(RIMS_COOKIE_CONSTANTS.LOGIN_TOKEN);

    // const resultConfig = {...config};
    //@ts-ignore
    config.headers = { ...config.headers };    
    if (token) {
      config.headers["Content-Type"] =
        config.responseType === "arraybuffer" &&
          JSON.stringify(config.data) === "{}"
          ? "application/octet-stream;charset=utf-8"
          : "application/json;charset=utf-8";
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["Accept-Language"] = languageformat || "";
      if (
        config.url &&
        (config.url.startsWith("/pm") || config.url.startsWith("/em"))
      ) {
        try {
          const referrerUrl = new URL(document.referrer);
          const parentHostname =  referrerUrl.hostname.split(".")[0];
          
          if (parentHostname === "ac") {
            const acTenantId = cookie.load(RIMS_COOKIE_CONSTANTS.AC_TENANT_ID);
            if (acTenantId) {
              config.headers["X-Tenant-Id"] = acTenantId;
            }
          } else {
            const tenantId = cookie.load(RIMS_COOKIE_CONSTANTS.USER_TENANT_ID);
            if (tenantId) {
              config.headers["X-Tenant-Id"] = tenantId;
            }
          }
        } catch (error) {
          const tenantId = cookie.load(RIMS_COOKIE_CONSTANTS.USER_TENANT_ID);
          if (tenantId) {
            config.headers["X-Tenant-Id"] = tenantId;
          }
        }
      }
    } else {
      config.headers["Content-Type"] = "application/json;charset=utf-8";
    }
    // token
    //   ? (config.headers = {
    //     "Content-Type":
    //       config.responseType === "arraybuffer" &&
    //         JSON.stringify(config.data) === "{}"
    //         ? "application/octet-stream;charset=utf-8"
    //         : "application/json;charset=utf-8",
    //     Authorization: `Bearer ${token}`,
    //     "Accept-Language": languageformat || ""
    //   })
    //   : (config.headers = {
    //     "Content-Type": "application/json;charset=utf-8",
    //   });
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            if (response.config?.url?.indexOf(refreshURL) > -1) {
              logoutFunction();
              window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
              console.log(
                "I catch err refreshURL 401/400/403 in request. will return"
              );
            }
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    console.log("err", err);
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      logoutFunction();
      console.log("I catch err refreshURL 401. will return");
      window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
      return;
    } else {
      switch (err.response.status) {
        case 401:
        case 403:
          SnackbarUtils.error("Your token is expired, please login again");
          logoutFunction();
          window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
          break;
        // break;
        case 500:
          const message =
            err.response.data?.message ||
            "There is something wrong with server, please try again later";
          SnackbarUtils.error(message);
          // if (localStorage.getItem(RIMS_LOCAL_STG_CONSTANTS.LOGIN_TOKEN)) {
          // }
          break;
        default:
          console.log("error", err.response.data?.message || "There is something wrong with server, please try again later");
        // SnackbarUtils.error('There is something wrong with server, please try again later')
      }
    }
    return Promise.reject(err);
  }
);

export default service;
